module.exports = __webpack_public_path__ + "img/add-instance-aside.560445cb.png";